import { Button, Input } from "@oc-labs/wt-storybook";
import { useEffect, useState } from "react";
import useModal from "../../../../hooks/useModal";
import ModalV2 from "../../../../components/ModalV2";
import useCompany from "../../../../hooks/useCompany";

export default function CreateCompanyModal() {
  const { isOpen, close } = useModal("admin-create-company");
  const [companyName, setCompanyName] = useState("");
  const { createCompany } = useCompany();

  useEffect(() => {
    if (!isOpen) {
      setCompanyName("");
    }
  }, [isOpen]);

  const handleCreateCompany = async () => {
    if (!companyName.trim()) return;
    try {
      await createCompany({ name: companyName });
      close();
    } catch (error) {
      console.error("Error creating company:", error);
    }
  };

  return (
    <ModalV2 name={"admin-create-company"} title="Create Company" className="w-[600px]">
      <div className="mt-4">
        <Input 
          label="Company Name"
          type="text"
          placeholder="Enter company name"
          className="mb-4"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleCreateCompany(e.target.value);
            }
          }}
        />
        <Button
          className="w-full bg-blue-600 text-white hover:bg-blue-700"
          onClick={handleCreateCompany}
          disabled={!companyName.trim()}
        >
          Create Company
        </Button>
      </div>
    </ModalV2>
  );
}